import React from 'react';
import { SectionHeader } from './SectionHeader';
export const RightSidebar = () => {
  const relatedVideos = [{
    id: '1',
    title: 'The River',
    artist: 'AURORA, Askjell',
    imageUrl: 'https://i.ytimg.com/vi/P7lE-G1oC34/maxresdefault.jpg'
  }, {
    id: '2',
    title: 'Storm',
    artist: '英特林, AURORA',
    imageUrl: 'https://i.ytimg.com/vi/7G1eLTV89dM/maxresdefault.jpg'
  }];
  return <div className="w-[340px] bg-[#121212] text-white p-4 overflow-y-auto" data-id="element-36">
      <div className="mb-6" data-id="element-37">
        <h2 className="text-2xl font-bold" data-id="element-38">It Happened Quiet</h2>
        <p className="text-[#b3b3b3]" data-id="element-39">AURORA</p>
        <div className="mt-4" data-id="element-40">
          <img src="https://i.scdn.co/image/ab67616d00001e02fb13ebe958ca179eb115789c" alt="Album Cover" className="w-full h-auto rounded-md" data-id="element-41" />
          <button className="mt-4 w-10 h-10 rounded-full bg-[#1DB954] flex items-center justify-center" data-id="element-42">
            <svg height="16" width="16" viewBox="0 0 16 16" fill="white" data-id="element-43">
              <path d="M3 1.713a.7.7 0 0 1 1.05-.607l10.89 6.288a.7.7 0 0 1 0 1.212L4.05 14.894A.7.7 0 0 1 3 14.288V1.713z" data-id="element-44"></path>
            </svg>
          </button>
        </div>
      </div>
      <div className="mb-6" data-id="element-45">
        <SectionHeader title="Related music videos" href="#" data-id="element-46" />
        <div className="mt-4 space-y-4" data-id="element-47">
          {relatedVideos.map(video => <div key={video.id} className="flex gap-3" data-id="element-48">
              <div className="w-20 h-20 flex-shrink-0" data-id="element-49">
                <img src={video.imageUrl} alt={video.title} className="w-full h-full object-cover rounded" data-id="element-50" />
              </div>
              <div data-id="element-51">
                <h3 className="text-sm font-medium" data-id="element-52">{video.title}</h3>
                <p className="text-xs text-[#b3b3b3]" data-id="element-53">{video.artist}</p>
              </div>
            </div>)}
        </div>
      </div>
      <div data-id="element-54">
        <SectionHeader title="About the artist" href="#" data-id="element-55" />
        <div className="mt-4" data-id="element-56">
          <img src="https://i.scdn.co/image/ab6761610000e5eb8ae7f2aaa9817a704a87ea98" alt="AURORA" className="w-full h-auto rounded-md" data-id="element-57" />
          <div className="mt-4" data-id="element-58">
            <p className="text-sm text-[#b3b3b3]" data-id="element-59">
              AURORA is a Norwegian singer-songwriter and producer. Her debut EP
              Running with the Wolves was released in 2015, followed by her
              debut studio album All My Demons Greeting Me as a Friend in 2016.
            </p>
          </div>
        </div>
      </div>
    </div>;
};